<template>
    
    <div>
    <Loader />
        <!---Map-->      
        <div v-if="userAllPlants!=null" id="map-container" class="full-map animated fadeIn">

       <MglMap 
        :accessToken="accessToken"
        :mapStyle="mapStyle" 
        :center="centerMap" 
        :zoom="zoom"
        container="map-container"
        :speed="1"
        @load="onMapLoaded"
        >
        <MglMarker  v-for="(plant,index) in this.userAllPlants" :key="`${index}-${plant.id}`"
        :coordinates= "[plant.address.long,plant.address.lat]"
        color="blue" >
            <img v-if="plant.controlunits && plant.id==selectedPlant && getError(plant)" slot="marker" src="/img/marker_error_sel.png" style="height:40px; width:auto"/>
            <img v-if="plant.controlunits && getError(plant)" slot="marker" src="/img/marker_error.png" style="height:40px; width:auto"/>
            <img v-if="plant.id==selectedPlant" slot="marker" src="/img/marker_sel.png" style="height:40px; width:auto"/>
            <img v-else slot="marker" src="/img/marker.png" style="height:40px; width:auto"/>

            <!-- Visualizzazione Popup con nome dell'impianto -->
            <MglPopup>
                  <div>
                    <div style="font-size:medium;"><b>{{plant.plantname}}</b></div>
                     <hr>
                    <div>{{plant.address.street}} {{plant.address.housenumber}}</div>
                    <div>{{plant.address.city}} - {{plant.address.country}}</div>
                    <hr>
                    <div v-if="plant.technology=='bluetooth'">
                        <i class="fa fa-bluetooth" aria-hidden="true"></i> BLUETOOTH <hr>
                    </div>
                    <div v-else>
                        <i class="fa fa-cloud" aria-hidden="true"></i>  {{ $t('central_units')}} 
                
                        <div v-for="(cu,index) in plant.controlunits">
                            <div style="font-size:x-small;">{{index+1}}) <b>{{cu.cutype.toUpperCase()}} {{cu.cuid}}</b> LAMP: {{cu.num_lamp_found}} ERR: {{cu.num_lamp_error}} </div>   
                        </div>              
                    </div>   
                    <hr>
                    <b-button class="ml-2 bg-primary btn-pill" style="color:white;" @click="openPlant(plant)">
                        {{ $t('go')}}
                    </b-button>    
                  </div>
            </MglPopup>

        </MglMarker>    

       </MglMap>


       </div>

        <!--Over Map-->
        <div id="allPlantsSearchContainer" v-if="userAllPlants!=null" :class="{'over-map':true, expanded: listVisible}">  
           
           <!-- Search -->
           <b-row class="searchPlantRow row-nomargin"> 
                <b-col> 
                    <b-input-group class="search-plant">
                        <b-input-group-prepend>
                            <a href="#" @click="toggleMap" class="mapButton"><i class="fa fa-map fa-2x ml-2 mt-2"></i></a>
                        </b-input-group-prepend>
                        <b-form-input v-model="searchPlant" :placeholder="$t('placeholder_search_plant')" class="ml-2 mr-4 mt-4 search-input"></b-form-input>
                        <b-input-group-append>
                            <a href="#" class="searchButton mt-3" @click="lensClicked"><i class="fa fa-search"></i></a>
                        </b-input-group-append>
                    </b-input-group>    
                </b-col>
           </b-row>

        <div class="plantListContainer p-4">
           <!-- Plant list --> 
           <b-row v-for="(plant,index) in this.filteredList" :key="`${index}-${plant.id}`">
                <b-col>
                    <div class="plantList" @click="selectPlant(plant.id)">
                        <span class="h5">{{plant.plantname}}
                             <b-button class="ml-2 bg-primary btn-pill" style="color:white;" variant="link" @click="openPlant(plant)">
                                {{$t('go')}}
                                <!--<i class="fa fas fa-external-link-square ml-2" />-->
                             </b-button>
                        </span>
                        <b-row>
                          <b-col cols="11">  
                            <span>{{plant.address.street}} {{plant.address.housenumber}} - {{plant.address.city}} ({{plant.address.prov}})</span>
                          </b-col>
                          <b-col cols="1" v-if="plant.controlunits">                           
                            <span v-if="getError(plant)"><i class="fa fax2 fa-warning" style="color:red"/></span>
                          </b-col>
                        </b-row>    
                        <div v-if="plant.controlunits" class="typo-label mt-3">
                            <span><strong>{{plant.controlunits.length}}</strong> {{$t("central_units")}}</span>
                            <span class="ml-3"><strong v-html="getTotalLamps(plant)"></strong> {{$t("lamps")}}</span>
                        </div>
                        <div v-else  class="typo-label mt-3"><strong>0</strong> {{$t("central_units")}}</div>
                    </div>
                </b-col>
           </b-row> 

           <!-- Add plant and total plants -->
           
        </div>

            <b-row class="allPlantsBottomRow my-4 mx-2">
                <b-col cols="8">
                    <add-plant/>
                </b-col>
                <b-col cols="4" class="mt-2">
                    <span class="typo_label pull-right">{{this.userAllPlants.length}} {{$t("plants_available")}}</span>    
                </b-col>    
           </b-row>

        </div>       
    
    </div>


</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import AddPlant from '@/components/AddPlant'
import { mapState, install } from 'vuex';

import Mapbox from "mapbox-gl";
import { MglMap,MglMarker,MglPopup} from "vue-mapbox";
import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'AllPlants',
    components: {
        AddPlant,
        MglMap,
        MglMarker,
        MglPopup,
        hideAt, showAt

    },    
    props: ['installerId','adminMode'],
    data() {
        return {
            userId: null,
            pageloading: true,
            searchPlant: "",
            accessToken: 'pk.eyJ1IjoiYmVnaGVsbGlkZXYiLCJhIjoiY2s4dHdzMTB1MDN2YjNwbXd3aTBjZ25payJ9.bGime-PtFWnugxAAL1G3yQ',
            mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
            centerMap:[11,40],
            zoom:5,
            selectedPlant:"",
            listVisible: false

        }
    },
    created() {
        this.map = null;
    },
    mounted() {
        console.log("allplants mounted, adminMode:" + this.adminMode+", installerId:" + this.installerId, this.userAllPlants);
        if (this.adminMode == true) {
            this.userId = this.installerId;
            return;
        }
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
        }
        else
        {
            console.log("MOUNTED")
        }
    },
    updated() {
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
        }
    },
    computed: {
         ...mapState(['loading']),
        
        userAllPlants() {
            var all = this.$store.state.userAllPlants;
            var latCenter=0;
            var longCenter=0;
            var self = this;
            if (all == null || all.length=="0") return null;    
            if (this.adminMode == true) {
                all = this.$store.state.userAllPlants.filter((p) => {
                    var installer = p.plant_users.find((u) => {
                        return u.role == 'installer' && u.userid == self.installerId;
                    })
                    return installer != null;
                });
            }       
            console.log("ALL PLANTS", all);
            return all;
        },

        filteredList() {
            return this.userAllPlants.filter(plant => {
            return (plant.plantname.toLowerCase().includes(this.searchPlant.toLowerCase()) 
                    || plant.address.street.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.city.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.prov.toLowerCase().includes(this.searchPlant.toLowerCase())
                    )
        })
        }
  

        },  
     watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val);
            if (val == false && this.userAllPlants == null ) {
                this.$store.dispatch('loadAllPlants', this.$route.params.userId);
            }
        }
     },        
    methods: {   
          lensClicked(e) {
              e.preventDefault();
              this.listVisible = true;
          },
          toggleMap(e) {
            e.preventDefault();
            this.listVisible = !this.listVisible;
            console.log("toggle map " + this.listVisible);
          },
          openPlant(plant)
          {
            let recPlants = this.$store.state.userLastPlants
            console.log("BEFORE",recPlants);
            for (var k=0;k<recPlants.length;k++)
            {
                if(recPlants[k].id==plant.id)
                {
                    var index=k;
                    console.log("INDEX",index);
                }
            }
            recPlants.splice(index,1)
            recPlants.unshift(plant)
            console.log("AFTER",recPlants);
            this.$store.state.userLastPlants = recPlants
            router.push({ name: 'HomeImpianto', params: { pid: plant.id } })  
          },
          selectPlant(id)
          { 
              this.selectedPlant=id;
              console.log("SELECTED",this.selectedPlant);
              this.listVisible = false;
          },
          getTotalLamps(plant)
          {
              var totalLamps=0;
              for(var k=0; k<plant.controlunits.length; k++)
                  totalLamps=totalLamps+parseInt(plant.controlunits[k].num_lamp_found); 
              console.log("TOTAL LAMPS: " , totalLamps);     
              return totalLamps;
          },
          getError(plant)
          {
              var plantError=false;
              for(var k=0; k<plant.controlunits.length; k++)
                  {
                    if(parseInt(plant.controlunits[k].num_lamp_error)>0)
                    plantError=true;
                  }  
              return plantError;
          },
          setCenterMap(){
             //find center of all the plants 
             var latCenter=0;
             var longCenter=0;
             var centerReal=[0,0];
             for (var j=0; j<this.userAllPlants.length;j++)
                {
                   latCenter=latCenter+parseFloat(this.userAllPlants[j].address.lat);
                   longCenter=longCenter+parseFloat(this.userAllPlants[j].address.long);
                }
                latCenter=latCenter/this.userAllPlants.length;
                longCenter=longCenter/this.userAllPlants.length;
                centerReal=[longCenter,latCenter];
                console.log("CENTERMAP",centerReal);
                return centerReal
            },
           
           async onMapLoaded(event){
                console.log("MAP LOADED");
                this.map=event.map;
                const asyncActions = event.component.actions;
                
                //go to center
                const newParams = await asyncActions.flyTo({
                    center: this.setCenterMap(),
                    zoom:this.zoom,
                    speed: 1
                 });

            },
        }

}
</script>

